import React, { useState, useEffect, useCallback } from 'react';
import { MdAdd } from 'react-icons/md';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
// Importando componentes
import Card from '~/components/Card';
import Table from '~/components/Table';
import Load from '~/components/Load';

import { Container, Menus, NewButton } from './styles';

export default function Incorporadora() {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);

  const getDados = useCallback(async () => {
    setLoading(true);
    const response = await api.get(`/incorporadora`);
    const data = response.data.map(i => ({
      name: i.name,
      statusFormat: i.status === '1' ? 'Ativo' : 'Inativo',
      status: i.status,
      id: i.id,
    }));
    setDados(data);
    setLoading(false);
  }, []);

  useEffect(() => {
    getDados();
  }, [getDados]);

  /**
   * Funções
   */

  async function handlerStatus(number) {
    try {
      setLoading(true);
      if (number.length > 1) {
        const res = number.map(async num => {
          const response = await api.delete(`/incorporadora/${num}`);
          return response.data;
        });
        const tr = Promise.all(res);
        const df = Promise.resolve(tr);
        df.then(result => {
          if (result[0] !== undefined) {
            toast.success(`Incorporadora ativado/desativado com sucesso`);
            getDados();
          }
        });
      } else {
        const response = await api.delete(`/incorporadora/${number}`);

        if (response.data) {
          toast.success(`Incorporadora ativado/desativado com sucesso`);
          getDados();
        }
      }
    } catch (error) {
      toast.error(`Erro ao ativar/desativar incorporadora`);
      getDados();
    } finally {
      setLoading(false);
    }
  }

  function handlerEditar(number) {
    history.push(`/incorporadora-edit/${number}`);
  }

  // Criando dados da coluna
  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Nome',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'statusFormat',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  if (loading) {
    return <Load />;
  }

  return (
    <>
      <Container>
        <h4>Incorporadora</h4>
        <span>Bem-vindo ao LeadFlow</span>
        <Card>
          <Menus>
            <NewButton to="/incorporadora-create">
              <MdAdd size={16} color="#FFF" />
              Novo
            </NewButton>
          </Menus>
          <Table
            title="Integrações"
            data={dados}
            columns={columns}
            ds={handlerStatus}
            ed={handlerEditar}
            messages="Você deseja ativar/desativar a incorporadora ?"
            st
          />
        </Card>
      </Container>
    </>
  );
}
